<div class="modal-content">
  <div class="modal-header">
    <h4 class="title is-size-4" translate="kwsLegal.info.title"></h4>
  </div>
  <div class="modal-body">
    <p class="has-text-grey mb-4" translate="kwsLegal.info.subtitle"></p>

    <app-please-be-patient></app-please-be-patient>

    <div [formGroup]="form" novalidate>
      <div class="field">
        <fino-input
          formControlName="bankaddress"
          inputAutocompleteOff
          validationIndicator
        ></fino-input>
      </div>
      <div class="field">
        <fino-input
          formControlName="organisation"
          inputAutocompleteOff
          validationIndicator
        ></fino-input>
      </div>
      <div class="field">
        <fino-input
          formControlName="name"
          inputAutocompleteOff
          validationIndicator
        ></fino-input>
      </div>

      <div class="columns">
        <div class="column">
          <div class="field">
            <fino-input
              formControlName="city"
              inputAutocompleteOff
              validationIndicator
            ></fino-input>
          </div>
        </div>
        <div class="column">
          <div class="field">
            <fino-input
              formControlName="street"
              inputAutocompleteOff
              validationIndicator
            ></fino-input>
          </div>
        </div>
      </div>

      <div class="field">
        <fino-input
          formControlName="email"
          inputAutocompleteOff
          validationIndicator
        ></fino-input>
      </div>

      <div class="field">
        <fino-input
          formControlName="www"
          inputAutocompleteOff
          validationIndicator
        ></fino-input>
      </div>

      <div class="columns">
        <div class="column">
          <div class="field">
            <fino-input
              formControlName="fax"
              inputAutocompleteOff
              validationIndicator
            ></fino-input>
          </div>
        </div>
        <div class="column">
          <div class="field">
            <fino-input
              formControlName="phone"
              inputAutocompleteOff
              validationIndicator
            ></fino-input>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <div class="is-flex is-centered mt-4">
      <button
        [primary]="true"
        type="button"
        class="has-text-weight-bold mr-1"
        [disabled]="formNotTouched"
        (click)="submit()"
        fino-button
        label="kwsLegal.submit"
      ></button>

      <button
        type="button"
        (click)="abort()"
        class="ml-1"
        fino-button
        label="kwsLegal.abort"
      ></button>
    </div>
  </div>
</div>
